export const LOGIN = "/";

export const ADMINS = "/Admin";
export const RISK_REPORT = "/RiskReport";
export const HOME = "/Home";
export const USERS = "/Users";
export const CERTIFICATE = "/Certificate";
export const SITE_AND_ZONE = "/SiteAndZone";
export const COURSES = "/Courses";
export const MY_ACCOUNT = "/MyAccount";
export const SUB_CONTRACTOR = "/SubContractor";
export const REPORT = "/Report";
export const TRAINING_REPORT = "/TrainingReport";
export const STORE_MANAGEMENT = "/StoreManagement";
export const ORDER_MANAGEMENT = "/OrderManagement";
export const PRODUCT_CATEGORY = "/ProductCategory";
export const SAFETY_POINT_MANAGEMENT = "/PointManagement/safetyPoint";
export const REWARD_POINT_MANAGEMENT = "/PointManagement/rewardPoint";
export const USER_GROUP = "/UserGroup";
export const BREACH_RECORD = "/BreachRecord";
export const COMPANY = "/Company";
export const ADVERTISEMENT = "/Advertisement";
export const CONFIGURATION = "/Configuration";
export const IMPORT_BATCH = "/ImportBatch";
export const SAFETY_POINT = "/SafetyPoint";
export const REWARD_POINT = "/RewardPoint";
export const BLACKLIST = "/Blacklist";
